import config from "config/index";
import loadIntercom from "helpers/loadIntercom";
import { logger } from "helpers/logger";
import handleLoadChatWidget from "./handleLoadChatWidget";
import { sendWebViewEvent } from "@Utils/webviewEvents";
import { WEB_VIEW_APP_EVENTS } from "@Utils/webApputils/analyticEvents";

// import handleLoadChatWidget from "./handleLoadChatWidget";

const handleChatWidgetOpen = async (isMobile = true, conversationFields?: any) => {
  if (config.IS_CHINA_APP) {
    // @ts-ignore
    if (typeof _MEIQIA !== "undefined" && _MEIQIA) {
      // @ts-ignore
      _MEIQIA("showPanel");
      sendWebViewEvent(WEB_VIEW_APP_EVENTS.ZENDESK_TOGGLE, { isOpened: true });
    }
    return;
  }
  if (config.ZENDESK_IS_VISIBLE === "true") {
    try {
      await handleLoadChatWidget(isMobile, conversationFields);
      // @ts-ignore
      if (typeof zE === "function") {
        // @ts-ignore
        zE("messenger", "open");
      }
    } catch (err) {
      logger.error(err);
    }
  }
  // @ts-ignore
  else if (typeof Intercom !== "undefined") {
    // @ts-ignore
    Intercom("show");
  } else {
    loadIntercom({ hideOnMobile: isMobile });
  }
};

export default handleChatWidgetOpen;
